<template>
    <div>
        <div id="content">
            <div class="birth-content">
                <div class="menu-bar not-fixed">
                    <a
                        class="btn link-blue"
                        v-if="births.length"
                        @click.prevent="printBirthList()"
                    >
                        <i class="fa fa fa-print"></i> Yazdır </a
                    ><a class="btn link-green" @click="getBirths()">
                        <i class="fa fa fa-sync"></i> Yenile
                    </a>
                    <span class="text no-mobile">Tarih :</span>
                    <input type="date" v-model="bdate" />

                    <a class="btn btn-blue" @click.prevent="addBirth()">
                        <i class="fa fa fa-plus"></i> Doğum Ekle
                    </a>
                </div>
                <div class="birth-list">
                    <div class="modal-overlay" v-if="birth.mode != 0">
                        <div class="modal-box small">
                            <span class="close" @click="closeBirth()"
                                >&times;</span
                            >
                            <h3>
                                {{ birth.mode == 1 ? "Yeni Doğum" : "Düzenle" }}
                            </h3>
                            <form
                                autocomplete="off"
                                v-on:submit.prevent
                                id="yeniDogum"
                            >
                                <div class="labeledit">
                                    <label for="p-birth"
                                        >Doğum Tarihi, Saati</label
                                    >
                                    <input
                                        type="datetime-local"
                                        v-model="birth.veri.birthv2"
                                        id="p-birth"
                                        required
                                    />
                                </div>
                                <div class="labeledit">
                                    <label for="p-baby"
                                        >Bebek Adı Soyadı*</label
                                    >
                                    <input
                                        type="text"
                                        v-model="birth.veri.bebek"
                                        id="p-baby"
                                        required
                                    />
                                </div>
                                <div class="labeledit">
                                    <label for="p-mommy"
                                        >Anne Adı Soyadı*</label
                                    >
                                    <input
                                        type="text"
                                        v-model="birth.veri.anne"
                                        id="p-mommy"
                                        required
                                    />
                                </div>
                                <div class="labeledit">
                                    <label for="p-mommykan"
                                        >Anne Kan Grubu</label
                                    >
                                    <select
                                        id="p-mommykan"
                                        v-model="birth.veri.annekan"
                                    >
                                        <option value>(Belli Değil)</option>
                                        <option value="0 Rh(+)">0 Rh(+)</option>
                                        <option value="A Rh(+)">A Rh(+)</option>
                                        <option value="B Rh(+)">B Rh(+)</option>
                                        <option value="AB Rh(+)">
                                            AB Rh(+)
                                        </option>
                                        <option value="0 Rh(-)">0 Rh(-)</option>
                                        <option value="A Rh(-)">A Rh(-)</option>
                                        <option value="B Rh(-)">B Rh(-)</option>
                                        <option value="AB Rh(-)">
                                            AB Rh(-)
                                        </option>
                                    </select>
                                </div>
                                <div class="labeledit">
                                    <label for="p-babykan"
                                        >Bebek Kan Grubu</label
                                    >
                                    <select
                                        id="p-babykan"
                                        v-model="birth.veri.kan"
                                    >
                                        <option value>(Belli Değil)</option>
                                        <option value="0 Rh (+)">
                                            0 Rh (+)
                                        </option>
                                        <option value="A Rh (+)">
                                            A Rh (+)
                                        </option>
                                        <option value="B Rh (+)">
                                            B Rh (+)
                                        </option>
                                        <option value="AB Rh (+)">
                                            AB Rh (+)
                                        </option>
                                        <option value="0 Rh (-)">
                                            0 Rh (-)
                                        </option>
                                        <option value="A Rh (-)">
                                            A Rh (-)
                                        </option>
                                        <option value="B Rh (-)">
                                            B Rh (-)
                                        </option>
                                        <option value="AB Rh (-)">
                                            AB Rh (-)
                                        </option>
                                    </select>
                                </div>
                                <div class="labeledit">
                                    <label for="p-babycoombs"
                                        >Bebek D.Coombs</label
                                    >
                                    <select
                                        id="p-babycoombs"
                                        v-model="birth.veri.coombs"
                                    >
                                        <option value>(Belli Değil)</option>
                                        <option value="D.Coombs (-)">
                                            D.Coombs (-)
                                        </option>
                                        <option value="D.Coombs (-+)">
                                            D.Coombs (-+)
                                        </option>
                                        <option value="D.Coombs (+)">
                                            D.Coombs (+)
                                        </option>
                                        <option value="D.Coombs (++)">
                                            D.Coombs (++)
                                        </option>
                                        <option value="D.Coombs (+++)">
                                            D.Coombs (+++)
                                        </option>
                                        <option value="D.Coombs (++++)">
                                            D.Coombs (++++)
                                        </option>
                                    </select>
                                </div>
                                <div class="labeledit">
                                    <label for="p-sekil">Doğum Şekli</label>
                                    <select
                                        id="p-sekil"
                                        v-model="birth.veri.sekil"
                                    >
                                        <option value>(Belli Değil)</option>
                                        <option value="C/S">C/S</option>
                                        <option value="NVD">NVD</option>
                                    </select>
                                </div>
                                <div class="labeledit">
                                    <label>Cinsiyet</label>

                                    <div class="toggle-group">
                                        <label for="p-cinsiyet-1">
                                            <input
                                                id="p-cinsiyet-1"
                                                class="modern"
                                                type="radio"
                                                name="cinsiyet"
                                                value="1"
                                                v-model="birth.veri.sex"
                                                required
                                            />
                                            <span>Erkek</span>
                                        </label>

                                        <label for="p-cinsiyet-2">
                                            <input
                                                id="p-cinsiyet-2"
                                                class="modern"
                                                type="radio"
                                                name="cinsiyet"
                                                value="2"
                                                v-model="birth.veri.sex"
                                                required
                                            />
                                            <span>Kız</span>
                                        </label>
                                    </div>
                                </div>
                                <div class="labeledit">
                                    <label for="p-apgar">Apgar</label>
                                    <input
                                        type="text"
                                        v-model="birth.veri.apgar"
                                        id="p-apgar"
                                        placeholder="Örn: 9-10 şeklinde APGAR skoru"
                                    />
                                </div>
                                <div class="labeledit">
                                    <label for="p-week">Doğum Haftası</label>
                                    <div class="multi-input">
                                        <input
                                            type="number"
                                            style="flex: 1 1 45%"
                                            v-model="birth.veri.week"
                                            placeholder="Örn: 34 haftalıksa 34 yazın"
                                            id="p-week"
                                        />
                                        <div class="space"></div>
                                        <input
                                            type="number"
                                            style="flex: 1 1 45%"
                                            v-model="birth.veri.day"
                                            placeholder="0-6 arası gün yazın"
                                            id="p-day"
                                        />
                                    </div>
                                </div>
                                <div class="labeledit">
                                    <label for="p-tarti">Tartı (gr)*</label>
                                    <input
                                        type="number"
                                        v-model="birth.veri.tarti"
                                        id="p-tarti"
                                        required
                                    />
                                </div>
                                <div class="labeledit">
                                    <label for="p-elisa">Anne ELISA</label>
                                    <select
                                        id="p-sekil"
                                        v-model="birth.veri.elisa"
                                    >
                                        <option value>(Belli Değil)</option>
                                        <option value="(-)">(-)</option>
                                        <option value="Hepatit B (+)">
                                            Hepatit B (+)
                                        </option>
                                        <option value="Hepatit C (+)">
                                            Hepatit C (+)
                                        </option>
                                        <option value="HIV (+)">HIV (+)</option>
                                        <option value="COVID-19 (+)">
                                            COVID-19 (+)
                                        </option>
                                    </select>
                                </div>
                                <div class="labeledit">
                                    <label for="p-durum">Durum</label>
                                    <select
                                        id="p-durum"
                                        v-model="birth.veri.durum"
                                    >
                                        <option value="0">
                                            Anne Yanına Verildi
                                        </option>
                                        <option value="1">
                                            Yatışı Yapıldı
                                        </option>
                                        <option value="2">Sevk Edildi</option>
                                        <option value="3">EX</option>
                                    </select>
                                </div>
                                <div class="labeledit">
                                    <label for="p-tarti">Takip</label>
                                    <textarea
                                        name
                                        id
                                        rows="4"
                                        v-model="birth.veri.takip"
                                    ></textarea>
                                </div>
                            </form>
                            <div class="button-bar">
                                <a
                                    class="btn link-red fl"
                                    v-show="birth.mode == 2"
                                    @click.prevent="deleteBirth()"
                                >
                                    <i class="fa fa fa-ban"></i> Sil
                                </a>
                                <button
                                    class="btn btn-green fr"
                                    form="yeniDogum"
                                    @click="saveBirth()"
                                >
                                    <i class="fa fa fa-save"></i> Kaydet
                                </button>
                                <div class="clear"></div>
                            </div>
                        </div>
                    </div>
                    <div id="printBirthList">
                        <table>
                            <thead>
                                <tr>
                                    <th colspan="11" class="p-header">
                                        <h3>YENİDOĞAN BEBEK İZLEM FORMU</h3>
                                        <h3>
                                            {{ bdate | moment("DD.MM.YYYY") }}
                                        </h3>
                                    </th>
                                </tr>
                                <tr>
                                    <th class="hidden"></th>
                                    <th>Bebek Adı Soyadı</th>
                                    <th>Anne Adı Soyadı</th>
                                    <th class="c-center">Anne Kan Grubu</th>
                                    <th>
                                        Bebek Kan Gr.
                                        <br />D.Coombs
                                    </th>
                                    <th class="c-center">Doğum Özellikleri</th>
                                    <th class="c-center">Bebek Özellikleri</th>
                                    <th class="c-center">Anne ELISA</th>
                                    <th class="c-center">Durum</th>
                                    <th class="c-center">Notlar</th>
                                    <th class="hidden"></th>
                                </tr>
                                <tr class="empty" v-if="!births.length">
                                    <td colspan="10">
                                        <div class="small-empty">
                                            <i
                                                class="fa fa-info-circle fa-3x"
                                            ></i>
                                            <span>Kayıtlı Doğum Yok</span>
                                        </div>
                                    </td>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    v-for="(t, index) in births"
                                    :key="t.id"
                                    @click="editBirth(t.id)"
                                    :class="warnings(t)"
                                >
                                    <td class="hidden w-4">
                                        <center>{{ index + 1 }}</center>
                                    </td>
                                    <td class="w-12">{{ t.bebek }}</td>
                                    <td class="w-12">{{ t.anne }}</td>
                                    <td class="w-8 c-center">
                                        {{ t.annekan }}
                                    </td>
                                    <td class="w-12" :class="coombs(t)">
                                        {{ t.kan }}
                                        <br />
                                        {{ t.coombs }}
                                    </td>
                                    <td class="w-8 c-center">
                                        {{ t.sekil }}
                                        <br />
                                        {{ t.apgar }}
                                        <br />
                                        {{ t.birth | moment("HH:mm") }}
                                    </td>
                                    <td class="w-8 c-center">
                                        {{ t.week }}w{{
                                            t.day > 0 ? "+" + t.day + "d" : ""
                                        }}
                                        <br />
                                        {{ t.tarti }} gr
                                        <br />
                                        {{ t.sex | toSex }}
                                    </td>
                                    <td class="w-8 c-center">{{ t.elisa }}</td>
                                    <td class="w-12 c-center">
                                        {{ t.durum | toBirthStatus }}
                                    </td>
                                    <td class="w-8">{{ t.takip }}</td>
                                    <td class="hidden">
                                        <a
                                            class="btn link-blue"
                                            @click.prevent="yatirBirth(t)"
                                        >
                                            <i class="fa fa fa-procedures"></i>
                                            Yatır
                                        </a>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div class="warnings" v-if="births.length">
                <div class="box" :class="tcoombs > 0 ? 'c-red' : 'c-green'">
                    <div class="icon" v-show="tcoombs > 0">
                        <i class="fa fa-2x fa-exclamation"></i>
                    </div>
                    <div class="title" v-show="tcoombs > 0">
                        <b>{{ tcoombs }}</b> bebek için D.Coombs TCB takibi var
                    </div>
                    <div class="icon" v-show="tcoombs == 0">
                        <i class="fa fa-2x fa-check-double"></i>
                    </div>
                    <div class="title" v-show="tcoombs == 0">
                        D.Coombs TCB takibi yok
                    </div>
                </div>
                <div
                    class="box"
                    :class="warns > 0 ? 'c-orange-dark' : 'c-green'"
                >
                    <div class="icon" v-show="warns > 0">
                        <i class="fa fa-2x fa-exclamation-triangle"></i>
                    </div>
                    <div class="title" v-show="warns > 0">
                        <b>{{ warns }}</b> bebeğin bilgileri tamamlanmamış
                    </div>
                    <div class="icon" v-show="warns == 0">
                        <i class="fa fa-2x fa-check-double"></i>
                    </div>
                    <div class="title" v-show="warns == 0">
                        Bebek bilgileri eksiksiz girilmiş
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import qs from "qs";
export default {
    name: "Birthlist",
    data() {
        return {
            bdate: null,
            births: [],
            birth: {
                mode: 0,
                veri: { sex: "-1" },
            },
            warns: 0,
            tcoombs: 0,
        };
    },
    watch: {
        bdate: {
            deep: true,
            immediate: false,
            handler: function () {
                this.getBirths();
            },
        },
        births: {
            deep: true,
            immediate: false,
            handler: function (bl) {
                this.tcoombs = 0;
                this.warns = 0;
                bl.forEach((b) => {
                    // Coombs
                    if (b.coombs != "D.Coombs (-)" && b.coombs != "") {
                        this.tcoombs += 1;
                    }
                    // Warns
                    if (
                        b.annekan == "" ||
                        b.kan == "" ||
                        b.coombs == "" ||
                        b.apgar == "" ||
                        b.sekil == "" ||
                        b.week == 0 ||
                        b.elisa == ""
                    ) {
                        this.warns += 1;
                    }
                });
            },
        },
    },
    computed: {},
    methods: {
        coombs(b) {
            if (b.coombs != "" && b.coombs != "D.Coombs (-)") {
                return "c-red";
            } else {
                return "";
            }
        },
        warnings(b) {
            var result = "";
            if (
                b.annekan == "" ||
                b.coombs == "" ||
                b.kan == "" ||
                b.apgar == "" ||
                b.sekil == "" ||
                b.week == 0 ||
                b.elisa == ""
            ) {
                result = "b-deactive";
            }
            if (b.durum == 2 || b.durum == 3) {
                result += " baby-gone";
            }
            return result;
        },
        closeBirth() {
            this.birth.mode = 0;
            this.getBirths();
        },
        addBirth() {
            this.birth.mode = 1;
            this.birth.veri = {
                q: "add",
                birthv2: this.$moment(new Date()).format("YYYY-MM-DDTHH:mm"),
                sex: 0,
                annekan: "",
                kan: "",
                coombs: "",
                sekil: "",
                elisa: "",
                apgar: "",
                week: "",
                day: "",
                durum: 0,
                takip: "",
            };
        },
        editBirth(id) {
            this.birth.mode = 2;
            this.birth.veri = this.births.find((t) => t.id === id);
            this.birth.veri.q = "update";
        },
        yatirBirth(baby) {
            let bilgiler = baby;
            event.stopPropagation();
            this.$router.push({ name: "NewYD", params: bilgiler });
        },
        deleteBirth() {
            this.$http({
                method: "post",
                url: "api/yenidogan/births.php",
                data: qs.stringify({
                    id: this.birth.veri.id,
                    q: "delete",
                }),
            }).then(() => {
                this.$snotify.success("Doğum silindi");
                this.$socket.client.emit("birth", this.birth);
                this.$store.dispatch("fillKHD");
                this.birth.mode = 0;
                this.getBirths();
            });
        },
        validateDate(list) {
            let r = true;
            list.forEach((item) => {
                if (!this.$moment(item).isValid()) {
                    r = false;
                }
            });
            return r;
        },
        saveBirth() {
            if (
                !this.validateDate([this.birth.veri.birthv2]) ||
                !this.birth.veri.bebek ||
                !this.birth.veri.anne ||
                !this.birth.veri.tarti ||
                !this.birth.veri.sex > 0
            ) {
                this.$snotify.warning(
                    "Devam etmek için Bebek Adı, Anne Adı, Cinsiyet ve Tartı girmelisiniz"
                );
            } else {
                this.$http({
                    method: "post",
                    url: "api/yenidogan/births.php",
                    data: qs.stringify(this.birth.veri),
                }).then(() => {
                    this.$snotify.success("Doğum başarıyla kaydedildi");
                    this.$socket.client.emit("birth", this.birth);
                    this.birth.mode = 0;
                    this.$store.dispatch("fillKHD");
                    this.getBirths();
                });
            }
        },
        printBirthList() {
            const options = {
                name: "_blank",
                specs: [
                    "height=800",
                    "height=800",
                    "titlebar=yes",
                    "scrollbars=yes",
                ],
                styles: ["https://pediatrim.net/print/birthlist.css"],
            };
            this.$htmlToPaper("printBirthList", options);
        },
        getBirths() {
            let self = this;
            this.$http({
                method: "post",
                url: "api/yenidogan/births.php",
                data: qs.stringify({
                    q: "get",
                    bdate: this.$moment(this.bdate).format("YYYY-MM-DD"),
                }),
            }).then(function (response) {
                self.births = response.data.data.birthlist;
            });
        },
    },
    created() {
        var n = this.$moment(new Date());
        this.bdate = n.format("YYYY-MM-DD");
    },
};
</script>

<style lang="scss">
.baby-gone {
    td {
        color: $gray-600 !important;
    }
}
</style>